import { render, staticRenderFns } from "./KiteHouse.vue?vue&type=template&id=139e70cb&scoped=true"
import script from "./KiteHouse.vue?vue&type=script&lang=js"
export * from "./KiteHouse.vue?vue&type=script&lang=js"
import style0 from "./KiteHouse.vue?vue&type=style&index=0&id=139e70cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139e70cb",
  null
  
)

export default component.exports